import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/relojchecador/incidencia-general/';

/**
 * GET Incidencia General
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciasGenerales = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Incidencia General
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getIncidenciaGeneral = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Incidencia General
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postIncidenciaGeneral = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Incidencia General
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchIncidenciaGeneral = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Incidencia General
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteIncidenciaGeneral = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Incidencia General
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarIncidenciaGeneral = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
